import { useStore } from "@/context/StoreContext";
import { Instagram, MessageCircle, Radio, ArrowUpRight } from "lucide-react";

export default function Community({ compact }) {
  const { business } = useStore();
  const b = business || {};
  const items = [
    { label: "Follow us on Instagram", href: b.instagram, icon: Instagram, cls: "from-pink-500 to-orange-400", testid: "community-instagram" },
    { label: "Join our WhatsApp Channel", href: b.whatsappChannel, icon: MessageCircle, cls: "from-green-500 to-emerald-500", testid: "community-whatsapp-channel" },
    { label: "Follow our Instagram Channel", href: b.instagramChannel, icon: Radio, cls: "from-purple-500 to-fuchsia-500", testid: "community-instagram-channel" },
  ].filter((x) => x.href);

  if (items.length === 0) return null;

  return (
    <section className={compact ? "" : "container-x py-10"} data-testid="community-section">
      {!compact && (
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 font-display">Join Our Community</h2>
          <p className="text-slate-500 mt-1">Stay updated on new arrivals, deals and gadget drops.</p>
        </div>
      )}
      <div className="grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
        {items.map((it) => (
          <a key={it.testid} href={it.href} target="_blank" rel="noreferrer" data-testid={it.testid}
            className={`group relative overflow-hidden rounded-xl p-5 text-white bg-gradient-to-br ${it.cls} hover:shadow-xl transition`}>
            <it.icon className="h-7 w-7" />
            <p className="mt-4 font-semibold text-sm leading-snug">{it.label}</p>
            <ArrowUpRight className="absolute top-4 right-4 h-5 w-5 opacity-70 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition" />
          </a>
        ))}
      </div>
    </section>
  );
}
